/* eslint-disable */
import React, {useContext} from 'react';
import { Typography, ThemeProvider, Link } from '@one-thd/sui-atomic-components';
import { ImpressionProvider } from '@thd-olt-component-react/impression';
import { getThemeByName } from '@thd-olt-component-react/stencil-themes';
import { HomepageContext } from '../context/HomepageContext';
import { CUSTOMER_TYPES } from '../../utils/index';
import classnames from 'classnames/bind';

const preferSectionTitleComponents = [
  'VisualNavigation'
];

Object.freeze(preferSectionTitleComponents);

export function FallbackSection({ children, id, title, theme, sectionCTAButton }) {
  const firstChildProps = children?.[0]?.props;
  const customRenderId = firstChildProps?.customRenderId;
  const { customerType } = useContext(HomepageContext);
  const isB2C = customerType === CUSTOMER_TYPES.B2C || customerType === CUSTOMER_TYPES.GUEST;
  const isB2BVariant = customRenderId === 'B2B Marketing Gallery';
  const { callToAction, destinationLink } = sectionCTAButton || {};

  function shouldDisplaySectionTitle () {
    const isSectionTitleDefined = !!title;
    const componentContainerHasTitle = children.length === 1 && !!firstChildProps?.title;
    return !componentContainerHasTitle && isSectionTitleDefined || preferSectionTitleComponents.includes(firstChildProps.componentName); 
  }

  const sectionTitle = shouldDisplaySectionTitle() ? (
    <div className="sui-flex md:sui-flex-row sui-justify-between sui-py-4">
      <div className="sui-pb-4 md:sui-pb-0">
        <Typography
          variant="h2"
          height="snug"
          color="primary"
        >
          {title}
        </Typography>
      </div>
      {destinationLink && callToAction && (
        <div className="sui-w-fit">
          <Link href={destinationLink}>
            {callToAction}
          </Link>
        </div>
      )}
    </div>
  ) : null;

  const gridColumns = isB2BVariant
    ? classnames(
      'sui-grid',
      'sui-grid-cols-1',
      'sm:sui-grid-cols-3',
      {
        'sui-gap-4 md:sui-gap-6 xl:sui-gap-8': isB2C,
        'sui-gap-5': !isB2C,
      }
    ) : classnames(
      'sui-grid',
      'sui-grid-cols-1',
      'sm:sui-grid-cols-2',
      {
        'sui-gap-4 md:sui-gap-6 xl:sui-gap-8': isB2C,
        'sui-gap-5': !isB2C,
        'md:sui-grid-cols-4': children.length >= 4,
        'sm:sui-grid-cols-2 md:sui-grid-cols-3':
          children.length === 3,
        'sm:sui-grid-cols-2 md:sui-grid-cols-2':
          children.length === 2,
        'sm:sui-grid-cols-1 md:sui-grid-cols-1':
          children.length <= 1,
      }
    );

  const sectionStyle = classnames(
    'sui-h-full sui-bg-primary sui-text-primary',
    {
      'sui-p-4': !isB2C,
    },
    {
      '!sui-rounded-[12px]': isB2C,
    }
  );

  return (
    <ThemeProvider theme={getThemeByName(theme)}>
    <div
      id={`section-php-${id}`}
      className={sectionStyle}
    >
      <ImpressionProvider
        data={{
          id,
          name: customRenderId || 'Section',
          component: 'Section',
          type: 'content'
        }}
      >
        <>
          {sectionTitle}
          <div className={classnames(gridColumns)}>
            {children.map(
              (child, index) => <React.Fragment key={index}>{child}</React.Fragment>
            )}
          </div>
        </>
      </ImpressionProvider>
    </div>
    </ThemeProvider>
  );
}